import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { getGlobalDepartments } from 'utils/personnelHelper';
import { getGlobalDepartmentRecords } from 'selectors/globalSelectors';
import { selectors as filtersSelectors } from '../Modules/filters';
import { selectors as userAssigneeListSelectors } from '../Modules/userAssigneeList';
import { transform as transformAssetList } from 'utils/DataTransform/Asset/AssetList';
import {
  transform as transformAssetDetails,
  transformPhoneDetails,
  transformSensorDetails,
  transformSensorForm,
} from 'utils/DataTransform/Asset/AssetDetail';
import { selectors as embeddedFormSelectors } from 'modules/embeddedForms/reducer';
import isEmpty from 'lodash/isEmpty';

export const getAssetListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getGlobalDepartmentRecords,
  (list, globalDepartmentRecords) => {
    if (!list) return [];
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    return transformAssetList(list, globalDepartmentList);
  },
);

export const getAssetListRaw = createSelector(
  dataGridTableSelectors.getGridTableList,
  list => {
    if (!list) return [];
    return list;
  },
);

export const getTotalRowsCount = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getAssetFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);
export const getAssetFormTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getGlobalDepartmentRecords,
  (details, globalDepartmentRecords) => {
    if (!details) {
      return {};
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    if (details.type.category === 'PHONE') {
      return transformPhoneDetails(details, globalDepartmentList);
    } else if (details.type.category === 'SENSOR') {
      return transformSensorForm(details, globalDepartmentList);
    } else {
      return transformAssetDetails(details, globalDepartmentList);
    }
  },
);
export const getAssetDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getGlobalDepartmentRecords,
  (details, globalDepartmentRecords) => {
    if (!details) {
      return {};
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    if (details.type.category === 'PHONE') {
      return transformPhoneDetails(details, globalDepartmentList);
    } else if (details.type.category === 'SENSOR') {
      return transformSensorDetails(details, globalDepartmentList);
    } else {
      return transformAssetDetails(details, globalDepartmentList);
    }
  },
);
export const getAssetDetailsRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details) {
      return {};
    }
    return details;
  },
);

export const getAssetFilterKey = createSelector(
  filtersSelectors.getFilterKey,
  filterKey => filterKey,
);

export const getAssetAssigneeList = createSelector(
  userAssigneeListSelectors.getUserList,
  userAssigneeList => userAssigneeList,
);

// embedded assetType selectors
export const embeddedAssetTypeDetails = createSelector(
  embeddedFormSelectors.getAssetTypesEmbeddedFormDetails,
  details => {
    if (isEmpty(details)) {
      return {};
    }
    // convert it into id and name list array

    return details;
  },
);
